import React, { useState, useEffect } from 'react';
import { BuscaAssinat } from '../../services/assinaturas';
import { ProgressSpinner } from 'primereact/progressspinner';

const ExibeAssinaturas = (props) => {
    const [image, setImage] = useState([]);
    const [mensagem, setMensagem] = useState([]);
    const [valida, setValida] = useState(true);
    const [loading, setLoading] = useState(false);
    const { key, inscricao } = props.match.params;

    useEffect(() => {
        async function loadAssinatura() {
            if (key) {
                await BuscaAssinat(inscricao, key)
                    .then((response) => {
                        if (response.ass_b64) {
                            setImage(response.ass_b64);
                            setValida(true);
                        } else if (response.length < 1) {
                            setMensagem('ops! Nenhum arquivo encontrado !');
                            //setMensagem('ops! Token invalido ou inspirado!');
                            setValida(false);
                            setLoading(true);
                        }
                        else {
                            //setMensagem('ops! Nenhum arquivo encontrado ou token invalido');
                            setMensagem('ops! Token invalido ou inspirado!');
                            setValida(false);
                            setLoading(true);
                        }
                    })
                    .catch(() => {
                        setMensagem('ops! Houve um erro não identificado');
                        setValida(false);
                        setLoading(true);
                    });
            } else {
                setMensagem('ops! Token não encontrada');
                setValida(false);
                setLoading(true);
            }
        }
        loadAssinatura();
    }, [loading]);

    setTimeout(() => {
        setLoading(true);
    }, 5000);

    if (!loading) {
        return (
            <div>
                <div className="exibirAssinatura p-col-12 p-md-12 p-lg-12">
                    <ProgressSpinner
                        style={{
                            width: '50px',
                            height: '50px',
                            marginTop: '50px',
                            marginLeft: '50px',
                        }}
                        strokeWidth="5"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </div>
            </div>
        );
    } else
        return (
            <div>
                {loading && valida ? (
                    <div className="exibirAssinatura p-col-12 p-md-12 p-lg-12">
                        <img
                            src={image}
                            style={{ width: '200px', marginTop: '40px' }}
                            alt="img"
                        />
                    </div>
                ) : (
                    <div className="exibirAssinatura p-col-12 p-md-12 p-lg-12">
                        <h1>{mensagem}</h1>
                    </div>
                )}
            </div>
        );
};

export default ExibeAssinaturas;
